const getErrorMessage = (componentName, propName, value) => `(${componentName}) Invalid prop provided: "${propName}". Value provided was "${value}". Please make sure the "${propName}" is provided with the correct type as documented. Prop documentation can be found at https://webcomponents.ns.nl/`;
const isPropUndefined = (prop) => typeof prop === "undefined" || prop === undefined;
const validateProps = (componentName, args) => {
  for (const [key, value] of Object.entries(args)) {
    if (isPropUndefined(value)) {
      console.error(getErrorMessage(componentName, key, value));
    }
  }
};

export { validateProps as v };
